
<!-- Banner Section -->
<div class="bg-white rounded-fluent-md shadow-fluent-shadow-2 p-6 mb-6">
  <div class="flex items-center justify-between flex-wrap gap-4">
    <div class="flex-1">
    </div>
    <div class="text-right">
      <b>FlowStudio for Teams</b> is
      <fluent-badge color="light" fill="primary">TEAMS</fluent-badge>
      Subscription Feature
    </div>
  </div>
</div>

<!-- Grid Layout -->
<div class="grid grid-cols-2 gap-8">

  <!-- Loading -->
  @if (contextState === 'loading') {
    <div class="col-span-2 bg-white rounded-fluent-md shadow-fluent-shadow-2 p-6">
      <p class="text-fluent-body text-fluent-neutral-60">Loading&hellip;</p>
    </div>
  }

  <!-- No workspace storage provisioned -->
  @if (contextState === 'noStorage') {
    <div class="col-span-2 bg-white rounded-fluent-md shadow-fluent-shadow-2 p-6">
      <p class="text-fluent-body text-fluent-warning">
        Your workspace is not yet provisioned with storage.
        Please contact support to complete setup.
      </p>
    </div>
  }

  <!-- No Teams license -->
  @if (contextState === 'noLicense') {
    <div class="col-span-2 bg-white rounded-fluent-md shadow-fluent-shadow-2 p-6">
      <div class="text-fluent-body text-fluent-error">
        No FlowStudio for Teams licenses found.
      </div>
    </div>
  }

  <!-- Ready -->
  @if (contextState === 'ready') {
    @if ((this.license$ | async); as license) {
      <div class="col-span-2 bg-white rounded-fluent-md shadow-fluent-shadow-2 p-6">
        <h2 class="text-fluent-subtitle font-semibold text-fluent-primary mb-4">Monitoring</h2>
        <div class="mb-4 text-fluent-body">
          <p>
            {{ (this.monitored$ | async).length }} flows monitored.
            Reporting from <strong>{{ (this.periodStart$ | async) | date:'y-MM-dd HH:mm:ss a' }}</strong>
            to <strong>{{ (this.periodEnd$ | async) | date:'y-MM-dd HH:mm:ss a' }}</strong>
          </p>
        </div>
        <app-teams-charts [runChartData$]="runChartData$" [flowChartData$]="flowChartData$" [labelContent]="labelContent"></app-teams-charts>
        <app-teams-flows [Type]="'monitor'"></app-teams-flows>
        <div class="text-fluent-primary cursor-pointer hover:underline mt-4" (click)="downloadCsv()">
          Download Links for details
        </div>
      </div>
      <!-- <kendo-gridlayout-item [col]="1" [colSpan]="2">
      <div style="padding:8px;"><b>Setup</b></div>
      <kendo-button [routerLink]="'/settings/setup'">Setup</kendo-button>
    </kendo-gridlayout-item> -->
    <div class="bg-white rounded-fluent-md shadow-fluent-shadow-2 p-6">
      <h2 class="text-fluent-subtitle font-semibold text-fluent-primary mb-4">Scanning Status</h2>
      @if ((scans$|async); as scans) {
        <div class="space-y-4">
          @for (scan of scans; track scan; let i = $index) {
            <div>
              @if (this.findAccount(scan.account); as account) {
                <p class="text-fluent-body">
                  Scanning with <strong>[{{ account.unique_name }}]</strong>
                  <span [class]="scan?.ended ? 'text-fluent-success' : 'text-fluent-warning'">
                    {{ scan?.ended ?  "completed" : "in progress" }}
                  </span>
                </p>
                <ul class="space-y-2 text-fluent-caption text-fluent-neutral-60 ml-4">
                  <li><i class="ms-Icon ms-Icon--Clock align-text-bottom"></i>&nbsp;{{ ((scansTimespan$ | async)||[]).at(i) }}@if (scan?.end) {
                  <span> on {{ scan?.end }}</span>
                }</li>
                <li><i class="ms-Icon ms-Icon--MapLayers align-text-bottom"></i>&nbsp;{{ scan?.envs }} environments</li>
                <li><i class="ms-Icon ms-Icon--PowerAppsLogo align-text-bottom"></i>&nbsp;{{ scan?.apps }} apps</li>
                <li><i class="ms-Icon ms-Icon--PowerAutomateLogo align-text-bottom"></i>&nbsp;{{ scan?.flows }} flows</li>
              </ul>
            }
          </div>
        }
        @if (scans.length == 0) {
          <div class="text-fluent-body text-fluent-neutral-60">
            To start scanning, add permissions for Power Automate and Power Apps.
          </div>
        }
      </div>
    } @else {
      <div class="text-fluent-body text-fluent-neutral-60">
        To start scanning, add permissions for Power Automate and Power Apps.
      </div>
    }
  </div>
  <div class="bg-white rounded-fluent-md shadow-fluent-shadow-2 p-6">
    <h2 class="text-fluent-subtitle font-semibold text-fluent-primary mb-4">Permissions</h2>
    <app-permission [accounts$]="this.accounts$" [user$]="this.user$" [workspace]="(this.license$|async)?.workspace"></app-permission>
  </div>
  <!-- <kendo-gridlayout-item title="FlowStudio API" [col]="2" [colSpan]="1">
  <ul>
    <li>use API for FlowStudio<br>
      <input type="checkbox" #notification kendoCheckBox disabled /> this can't currently be enabled.
    </li>
  </ul>
</kendo-gridlayout-item> -->
<div class="bg-white rounded-fluent-md shadow-fluent-shadow-2 p-6">
  <h2 class="text-fluent-subtitle font-semibold text-fluent-primary mb-4">License</h2>
  <div class="space-y-2 text-fluent-body">
    <div><strong>Role:</strong> {{ license.user_type }}</div>
    <div><strong>Assigned:</strong> {{ license.license_teams_assigned }}</div>
    <div><strong>Workspace:</strong> {{ license.workspace }}</div>
    <div style="background:#fef9c3; margin-left:-1rem; margin-right:-1rem; padding:0.25rem 1rem;" title="Flow capacity data may not reflect live subscription"><strong>Flow Capacity:</strong> {{ workspaceFlowCapacity() }}</div>
  </div>
</div>
<div class="bg-white rounded-fluent-md shadow-fluent-shadow-2 p-6">
  <h2 class="text-fluent-subtitle font-semibold text-fluent-primary mb-4">Settings</h2>
  <app-schedule [rules$]="rules$"></app-schedule>
  <div class="text-fluent-body text-fluent-neutral-60 mt-4">
    <p>BYO storage key - please contact us to discuss setting up your own Azure Storage for run monitoring</p>
  </div>
</div>
<!-- <kendo-gridlayout-item [col]="2" [colSpan]="1">
<div style="padding:8px;"><b>Storage</b></div>
</kendo-gridlayout-item> -->
}<!-- end license$ -->
}<!-- end ready -->

</div>
